<p class="font-normal text-sm italic text-gentle"><ng-content></ng-content></p>
